import {Injectable} from '@angular/core';
import moment from 'moment-timezone';

import {
  FieldUiDataFileUploadObj,
  FieldUiDataObj,
  FieldValidationObj,
  ReportUiDataObj, TrackerVariableObj, VariableType
} from '../../../generated/generated-core.model';
import {
  MOMENT_DATE_FORMAT_SECONDS_FORMAT,
  MOMENT_DATE_TIME_FORMAT,
  TIME_FORMAT
} from '../../consts/date-time-format-consts';

@Injectable({
    providedIn: 'root'
})
export class MxUtilsService {

    public buildFileUploadField(allowedTypes: string, showInCompactMode?: boolean): FieldUiDataObj {
        let boFieldValidationObj: FieldValidationObj = new FieldValidationObj();
        boFieldValidationObj.required = true;
        let boField: FieldUiDataFileUploadObj = {
            label: 'File',
            name: 'file',
            type: 'fileupload',
            hidden: false,
            validation: boFieldValidationObj,
            disabledOnEdit: false,
            disabledOnEditValues: null,
            disabledDependsOnField: null,
            disabled: false,
            labelCode: null,
            dependsOn: null,
            allowedTypes: allowedTypes,
            sublist: null,
            defaultValue: null,
            showIf: null,
            showChildDependOn: null,
            showInCompactMode: showInCompactMode,
            informationKey: null
        };
        return boField;
    }

    constructor(
    ) {
    }

    public flattenObject(obj: any, delimiter?: string): any {
        let flattenedObject = {};

        for (let i in obj) {
            if (!obj.hasOwnProperty(i)) { continue; }

            if ((typeof obj[i]) === 'object') {
                let flatObject = this.flattenObject(obj[i]);
                for (let x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) { continue; }
                    if (delimiter) {
                        flattenedObject[i + delimiter + x] = flatObject[x];
                    } else {
                        flattenedObject[x] = flatObject[x];
                    }
                }
            } else {
                flattenedObject[i] = obj[i];
            }
        }
        return flattenedObject;
    }

    public convertPayloadDatesToTimestamps(obj: any): any {
        for (let key in obj) {
            if (obj[key] && typeof obj[key] === 'object') {
                if (moment.isMoment(obj[key])) {
                    let date = obj[key];
                    obj[key] = moment(date).format();
                } else {
                    this.convertPayloadDatesToTimestamps(obj[key]);
                }
            }
        }
        return obj;
    }

    public convertPayloadDatesToTimestampsWithFormat(obj: any, input: Array<ReportUiDataObj>): any {
        for (let key in obj) {
            if (obj[key] && typeof obj[key] === 'object') {
                if (input && moment.isMoment(obj[key])) {
                    let date = obj[key];
                    let field = input.find(value => value.field === key);
                    obj[key] = (<any>moment(date)).formatWithJDF(field.dateTimeFormat);
                } else {
                    this.convertPayloadDatesToTimestampsWithFormat(obj[key], input);
                }
            }
        }
        return obj;
    }

    public getQueryStringFromArray(queryParams: Array<{field: string, value?: any}>): string {
        let query = [];
        for (let item of queryParams) {
            query.push(encodeURIComponent(item.field) + '=' + encodeURIComponent(item.value));
        }

        return query.join('&');
    }


    public formatDatesWithFormat(obj: any, variables: Array<TrackerVariableObj>, variable?: string): any {
        for (let key in obj) {
            if (obj[key] && typeof obj[key] === 'object') {
                if (variable && moment.isMoment(obj[key])) {
                    let date = obj[key];
                    let variableType = variables.find(trackerVar => trackerVar.name === variable).type;
                    obj[key] = moment(date).format(this.getDateFormat(variableType));
                } else {
                    this.formatDatesWithFormat(obj[key], variables, obj['variable']);
                }
            }
        }
        return obj;
    }

    private typeDateFormat: Map<string, string> = new Map([
        ['DATE', MOMENT_DATE_FORMAT_SECONDS_FORMAT],
        ['DATETIME', MOMENT_DATE_TIME_FORMAT],
        ['TIME', TIME_FORMAT]
    ]);

    public getDateFormat(variableType: VariableType): string {
        return this.typeDateFormat.get(variableType);
    }
}
